module.exports = __webpack_public_path__ + "img/hero.62097de3.jpg";